import db from '@/utils/localstorage'

const key = 'application_publish'

export function setAppId(value) {
  return db.save(key, value)
}

export function getAppId() {
  return db.get(key, '')
}
